// extracted by mini-css-extract-plugin
export default {"link":"Social_link__wgTkM","whatsapp":"Social_whatsapp__y42yl","vk":"Social_vk__i-aXJ","telegram":"Social_telegram__ZGhkS"};